import { ResourcesConfig } from 'aws-amplify';

import { environment } from '.';
import { Environment } from './types';

type ConfigEnv = {
  [key in Environment]: ResourcesConfig;
};

const dev: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-west-2_V8I6DuORj',
      userPoolClientId: '1oknn840mu1mopec387e113nr',
      identityPoolId: 'us-west-2:c05656cc-fd86-4c89-abe9-2089d2dd6f1e',
      allowGuestAccess: true,
    },
  },
  API: {
    GraphQL: {
      endpoint:
        'https://lm5sn3bx2rettnhfy7bd5yuwvy.appsync-api.us-west-2.amazonaws.com/graphql',
      region: 'us-west-2',
      defaultAuthMode: 'userPool',
    },
  },
  Analytics: {
    Pinpoint: {
      appId: '780140a7bd624083914ae1129de1422b',
      region: 'us-west-2',
    },
  },
};

const config: ConfigEnv = {
  local: dev,
  dev,
  production: {
    Auth: {
      Cognito: {
        userPoolId: 'us-west-2_YmwGAd3ju',
        userPoolClientId: '6nnvkf9o6f3bcm54t411l4cl4u',
        identityPoolId: 'us-west-2:fb6c4db0-eb35-4d3a-9acf-6432a1983f3c',
        allowGuestAccess: true,
      },
    },
    API: {
      GraphQL: {
        endpoint:
          'https://3w5s6bzgwbgr3jf43uggcmxw3y.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        defaultAuthMode: 'userPool',
      },
    },
    Analytics: {
      Pinpoint: {
        appId: '994978da01ba49ccb7b1e278c57eac84',
        region: 'us-west-2',
      },
    },
  },
};

export default config[environment];
